import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type { Request, Response } from '../types/get-delivery-tax';
import { HttpMethod } from '@/shared/contracts/http-client.contract';
import { HttpKyClient } from '@/shared/http/ky.adapter';

import { ENDPOINT } from '../types/get-delivery-tax';
import { UIError } from '@/shared/utils/ui-error';

export type UseCaseInput = Request;
export type UseCaseOutput = Response;

export class GetDeliveryTaxUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: HttpKyClient;

  constructor(client: HttpKyClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { store_slug, address_id } = input;

    if (!store_slug) {
      throw new Error('Store slug and address id are required');
    }

    if (!address_id) {
      throw new UIError('ADDRESS_REQUIRED', 'É obrigatório informar um endereço');
    }

    const response = await this.client.sendRequest<UseCaseOutput, void>({
      endpoint: ENDPOINT(store_slug, address_id),
      method: HttpMethod.GET,
    });

    return {
      delivery_tax: Number(response.delivery_tax),
    };
  }
}
